import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import "../employees/index.css";
import { getAllPaymentsAndDisbursment } from "../../../apis/expences";
import { Moment } from "moment";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const DisburseMent_Loan = () => {
  const [customerData, setCustomerData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });

  const { start, end } = state;
  const loginData = sessionStorage.getItem("info");

  const fetchAllEmployees = async () => {
    try {
      const parsedLogin = loginData ? JSON.parse(loginData) : {};
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        id: parsedLogin.id,
        user_id: parsedLogin.user_id,
        type: parsedLogin.type,
      };

      const response = await getAllPaymentsAndDisbursment(data);
      const flattened: any[] = [];

      response?.data?.forEach((item: any, _index: any) => {
        const customerName = item.customer?.full_name || "--";
        const loanAccountNumber = item.loans?.loan_id || "--";
        const customerAccountNumber = item.customer?.loanAccountNumber || "--";

        if (item.disbursement?.amount && item.disbursement?.disbursement_date) {
          flattened.push({
            key: `dis-${_index}`,
            type: "Disbursement",
            amount: item.disbursement.amount,
            receivedPayment: "--",
            paymentMode: item.disbursement.type,
            paymentDate: item.disbursement.disbursement_date,
            customerName,
            loanId: item.loan_id,
            loanAccountNumber,
            customerAccountNumber,
          });
        }

        item.payments?.forEach((payment: any, _idx: any) => {
          flattened.push({
            key: `dis-${_idx}`,
            type: "Payment Received",
            amount: "--",
            receivedPayment: payment.paymentAmount || 0,
            paymentMode: payment.paymentMode,
            paymentDate: payment.paymentDate,
            customerName,
            loanId: payment.loanId,
            loanAccountNumber,
            customerAccountNumber,
          });
        });
      });

      response?.expensesData?.forEach((expense: any, _index: any) => {
        flattened.push({
          key: `dis-${_index}`,
          type: "Expenses",
          amount: expense.amount || 0,
          receivedPayment: "--",
          paymentMode: expense.cash_bank,
          paymentDate: expense.createdAt?.split("T")[0],
          customerName: expense.title || "Expense",
          loanId: "",
        });
      });

      setCustomerData(flattened);
      setFilteredData(flattened);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = (value: string) => {
    setSearch(value);
    const filtered = customerData.filter((item) => {
      return (
        item.customerName?.toLowerCase().includes(value.toLowerCase()) ||
        item.mobile?.toString().includes(value)
      );
    });
    setFilteredData(filtered);
  };

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Data");
    XLSX.writeFile(workbook, "loan_disbursement_data.xlsx");
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "Date",
      "Customer Name",
      "Customer Account Number",
      "Loan Account Number",
      "Type",
      "Payment Mode",
      "Payment",
      "Received Payment",
    ];
    const rows = filteredData.map((item) => [
      item.paymentDate,
      item.customerName,
      item.customerAccountNumber,
      item.loanAccountNumber,
      item.type,
      item.paymentMode,
      item.amount,
      item.receivedPayment,
    ]);

    doc.autoTable({
      head: [columns],
      body: rows,
    });
    doc.save("loan_disbursement_data.pdf");
  };

  const columns = [
    { title: "Date", dataIndex: "paymentDate" },
    { title: "Customer Name", dataIndex: "customerName" },
    { title: "Customer Account Number", dataIndex: "customerAccountNumber" },
    { title: "Loan Account Number", dataIndex: "loanAccountNumber" },
    { title: "Type", dataIndex: "type" },
    { title: "Payment Mode", dataIndex: "paymentMode" },
    { title: "Payment", dataIndex: "amount" },
    { title: "Received Payment", dataIndex: "receivedPayment" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="d-flex align-items-center flex-wrap row-gap-3">
              <div className="me-3">
                <label style={{ color: "#000" }}>Search</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search by Name or Mobile"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{
                    backgroundColor: "#b4b4b447",
                    padding: "0.2rem 0.85rem",
                    marginTop: "5px",
                  }}
                />
              </div>

              <div className="input-icon-end position-relative">
                <label style={{ color: "#000" }}>Date Range</label>
                <PredefinedDateRanges state={state} setState={setState} />
              </div>

              <div
                style={{
                  marginTop: "28px",
                  marginLeft: "20px",
                }}
              >
                <button
                  className="btn btn-primary"
                  onClick={fetchAllEmployees}
                  style={{
                    padding: "4px 12px",
                    background: "#3ab54b",
                    border: "none",
                  }}
                >
                  Submit
                </button>
              </div>

              <div
                style={{
                  margin: "20px 0px 0px 6rem",
                }}
              >
                <div className="dropdown me-3">
                  <button
                    className="dropdown-toggle btn btn-white"
                    style={{ background: "#3ab54bbf", color: "#fff" }}
                    data-bs-toggle="dropdown"
                  >
                    Export
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={handleExportPDF}
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={handleExportExcel}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body p-0">
            {filteredData.length > 0 && (
              <Table
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisburseMent_Loan;
